<template>
  <div>
    <div class="home_top">
      <!-- $store.state.user.icon -->
      <img class="left" :src="icon" />
      <div class="right">
        <p>{{nick}}</p>
        <span>{{phone}}</span>
      </div>
    </div>
    <div class="home_bottom">
      <div class="title">
        <h3>未完成订单</h3>
        <router-link :to="{ path: '/orderList', query: { key: 2 } }">查看全部订单</router-link>
      </div>
      <div class="list">
        <div class="no_result" v-if="total == 0">
          <img src="../../assets/images/icon_5.png" />
          <p>已经很久买有下单了哦！</p>
        </div>
        <div class="order_list" v-for="(item,index) in orderArr" :key="index">
          <!-- <div class="title">下单时间：{{item.createTime | dateFormat}}&ensp;&ensp;&ensp;&ensp;订单号：{{item.orderSn}}</div> -->
          <!-- <ul class="goods">
            <li v-for="(goods,indes) in item.orderItemList" :key="indes"><img :src="goods.productPic" /></li>
          </ul> -->
          <ul class="goods">
            <template v-for="goods,indes in item.orderItemList">
              <li v-if="indes < 3"><img @click="onDetail(item.id)" :src="goods.productPic" /></li>
            </template>
          </ul>
          <div class="number">
            <em>共{{item.orderItemList.length}}种商品</em>
          </div>
          <div class="status">
            <em>
              <span v-if="item.status == 0">待付款</span>
              <span v-if="item.status == 1">待发货</span>
              <span v-if="item.status == 2">待收货</span>
              <span v-if="item.status == 3">待评价</span>
              <span v-if="item.status == 4">已完成</span>
              <span v-if="item.status == 5">已取消</span>
              <span v-if="item.status == 6">已关闭</span>
            </em>
          </div>
          <div class="price">
            <em>
              <span>￥{{item.payAmount}}</span>
              <span>（含运费：￥{{item.freightAmount}}元）</span>
            </em>
          </div>
          <div class="opera">
            <em>
              <!--  v-if="item.status == 3" -->
              <!-- <span v-if="item.status == 2"><a href="javascript:void(0)">申请售后</a></span> -->
              <span v-if="item.status == 3"><a href="javascript:void(0)" @click="orderEval(item.id)">评价</a></span>
              <span v-if="item.status == 0"><a href="javascript:void(0)" @click="payCompo(item.id,item.payType)">付款</a></span>
              <span v-if="item.status == 0"><a href="javascript:void(0)" @click="orderCancel(item.id)">取消订单</a></span>
              <span v-if="item.status > 1 && item.status < 5"><a href="javascript:void(0)" @click="orderCourier(item.deliverySn,item.deliveryCompany)">查看物流</a></span>
              <span v-if="item.status == 2"><a href="javascript:void(0)" @click="orderSure(item.id)">确认收货</a></span>
              <span><a href="javascript:void(0)" @click="onDetail(item.id)">查看详情</a></span>
            </em>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../bus.js'
import { orderList, orderCancel, orderReceive } from '@/api/order'
import { webWechatPay, webAlipay } from '@/api/pay'
import { expreessInquiry } from '@/api/aliyun'
export default {
  name: 'home',
  data() {
    return {
      icon: '', //头像
      nick: '', //昵称
      phone: '', //手机号码
      orderArr: [],
      total: '', // 商品总数
      pagenum: 1, // 当前页码
      pagesize: 5, // 每页条数
    }
  },
  created() {
    this.$emit('getUser', this.$route.query.key)
    let userInfo = JSON.parse(localStorage.getItem('userInfo'))
    this.icon = userInfo.icon
    this.nick = userInfo.nick
    this.phone = userInfo.phone
    this.order()
  },
  methods: {
    // 未完成订单
    async order() {
      let _this = this
      const res = await orderList({
        pageSize: _this.pagesize,
        pageNum: _this.pagenum,
        status: 0,
      })
      console.log(res)
      if (res.code == 200) {
        _this.orderArr = res.data.list
        _this.total = res.data.total
      }
    },
    // 付款
    async payCompo(orderSn, payType) {
      let _this = this
      if (payType == 0) {
        // 支付宝支付
        const res = await webAlipay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "payali",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
        // 支付宝支付
        // _this.$http
        //   .get(`/pay/alipay/getWebAlipay?out_trade_no=${orderSn}`)
        //   .then(res => {
        //     console.log(res)
        //     let routeData = _this.$router.resolve({
        //       path: 'payali',
        //       query: {
        //         orderid: orderSn,
        //         result: res.data.data,
        //       },
        //     })
        //     window.open(routeData.href, '_blank')
        //   })
      } else {
        // 微信支付
        const res = await webWechatPay({
          out_trade_no: orderSn
        });
        console.log(res);
        if (res.code == 200) {
          let router = _this.$router.resolve({
            path: "paywx",
            query: {
              orderid: orderSn,
              result: res.data
            }
          });
          window.open(router.href, "_blank");
        }
        // 微信支付
        // _this.$http
        //   .get(`/pay/wechat/getWebWechatPay?out_trade_no=${orderSn}`)
        //   .then(res => {
        //     console.log(res)
        //     let routeData = _this.$router.resolve({
        //       path: 'paywx',
        //       query: {
        //         orderid: orderSn,
        //         result: res.data.data,
        //       },
        //     })
        //     window.open(routeData.href, '_blank')
        //   })
      }
    },
    // 取消订单
    orderCancel(id) {
      let _this = this
      this.$confirm('此操作将取消订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          const res = await orderCancel(id)
          console.log(res)
          if (res.code == 200) {
            console.log(res.data)
            this.orderTab(_this.status)
          }
          // const res = await this.$http.post(`/order/cancel/${id}`)
          // const { data: { code, data, message } } = res
          // console.log(res)
          // if (code == 200) {
          //   console.log(data)
          //   this.orderTab(this.status)
          // }
          this.$message({
            type: 'success',
            message: '删除成功!',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // 查看详情
    onDetail(id) {
      let router = this.$router.resolve({
        path: '/orderDetail',
        query: {
          id: id,
          key: 2,
        },
      })
      window.open(router.href, '_blank')
    },
    // 查看物流
    orderCourier(sn, cm) {
      console.log(sn)
      console.log(cm)
      this.orderCourierShow = 1
      // this.courierDetail(sn,cm)
    },
    // 物流详情
    async courierDetail(sn, cm) {
      const res = await expreessInquiry({
        courierNumber: sn,
        courierCompany: cm
      })
      console.log(res)
      if (res.code == 200) {
        console.log(res.data)
        let courier = JSON.parse(res.data)
        this.courierArr = courier.Traces.reverse()
      }
      // const res = await this.$http.post(
      //   `/aliyun/oss/expreessInquiry?courierNumber=${sn}&courierCompany=${cm}`
      // )
      // const { data: { code, data, message } } = res
      // console.log(res)
      // if (code == 200) {
      //   console.log(data)
      //   let courier = JSON.parse(data)
      //   this.courierArr = courier.Traces.reverse()
      // }
    },
    courierSplit(name) {
      return name.split(' ')
    },
    // 关闭物流弹窗
    orderClose() {
      this.orderCourierShow = 0
    },
    // 确认收货
    orderSure(id) {
      let _this = this
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(async () => {
          const res = await orderReceive(id)
          console.log(res)
          if (res.code == 200) {
            console.log(res.data)
            this.orderTab(_this.status)
          }
          // const res = await this.$http.post(`/order/receive/${id}`)
          // const { data: { code, data, message } } = res
          // console.log(res)
          // if (code == 200) {
          //   console.log(data)
          //   this.orderTab(this.status)
          // }
          this.$message({
            type: 'success',
            message: '收货成功!',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消收货',
          })
        })
    },
    // 评价
    orderEval(id) {
      this.$router.push({
        path: '/evalGoods',
        query: {
          id: id,
          key: 2,
        },
      })
    },
  },
  mounted() {
    let _this = this
    // Bus.$on('userInfo', function(user) {
    //   console.log(user)
    //   _this.icon = user.icon
    //   _this.nick = user.nick
    //   _this.phone = user.phone
    // })
  },
}
</script>

<style scoped>
.home_top {
  width: 982px;
  height: 184px;
  padding: 42px 46px;
  margin-bottom: 25px;
  background: linear-gradient(
    0deg,
    rgba(205, 188, 152, 1) 0%,
    rgba(223, 210, 183, 1) 100%
  );
  overflow: hidden;
}
.home_top .left {
  float: left;
  width: 100px;
  height: 100px;
  background: rgba(230, 229, 227, 1);
  border-radius: 50%;
  margin-right: 20px;
}
.home_top .right {
  float: left;
  padding: 27px 0;
}
.home_top .right p,
.home_top .right span {
  float: left;
  width: 100%;
  color: #333;
  font-size: 18px;
}
.home_top .right p {
  padding-bottom: 15px;
}
.home_bottom {
  width: 982px;
  height: 601px;
  border: 1px solid rgba(218, 218, 218, 1);
  border-bottom-width: 0;
}
.home_bottom .title {
  width: 980px;
  height: 46px;
  padding: 0 35px 0 24px;
  background: rgba(244, 244, 244, 1);
  border-bottom: 1px solid rgba(218, 218, 218, 1);
}
.home_bottom .title h3 {
  float: left;
  color: #333;
  font-size: 18px;
  line-height: 46px;
}
.home_bottom .title a {
  float: right;
  color: #333;
  line-height: 46px;
}
.home_bottom .no_result {
  padding: 145px 0;
}
.order_list {
  width: 100%;
  height: 160px;
  /* margin-bottom: 21px; */
  border-bottom: 1px solid rgba(218, 218, 218, 1);
  overflow: hidden;
}
.order_list em {
  height: 160px;
  font-style: normal;
  display: table-cell;
  vertical-align: middle;
}
.order_list .goods {
  float: left;
  width: 390px;
  padding: 24px 0 24px 20px;
}
.order_list .goods li {
  float: left;
  width: 110px;
  height: 110px;
  margin-right: 12px;
}
.order_list .goods li img {
  float: left;
  width: 110px;
  height: 110px;
}
.order_list .number {
  float: left;
  width: 148px;
  color: #333;
  text-align: center;
}
.order_list .number em {
  width: 148px;
}
.order_list .status {
  float: left;
  width: 140px;
  color: #ff3232;
  text-align: center;
}
.order_list .status em {
  width: 140px;
}
.order_list .price {
  float: left;
  width: 156px;
  text-align: center;
  border-left: 1px solid rgba(218, 218, 218, 1);
}
.order_list .price em {
  width: 156px;
}
.order_list .price span {
  display: block;
  padding: 8px 0;
}
.order_list .opera {
  float: left;
  width: 146px;
  text-align: center;
  border-left: 1px solid rgba(218, 218, 218, 1);
}
.order_list .opera em {
  width: 146px;
}
.order_list .opera span {
  display: block;
}
.order_list .opera span a {
  color: #69c;
  line-height: 22px;
}
</style>